
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publishing/scheduler",
      function () {
        return require("private-next-pages/publishing/scheduler/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publishing/scheduler"])
      });
    }
  